module.exports = __webpack_public_path__ + "static/img/mask-task.56d6ff1.png";


//////////////////
// WEBPACK FOOTER
// ./static/mask-task.png
// module id = pkET
// module chunks = 0